<template>
    <div>
        <kgr-child-parent-relations-data-provider :child-id="childId">
            <template #default="relationsScope">
                <kgr-empty
                    v-if="relationsScope.data.length <= 1"
                    :value="$t('Es sind keine weiteren Bezugspersonen vorhanden.')"
                />
                <div v-else>
                    <template v-for="relation in relationsScope.data">
                        <div
                            v-if="!relation.isPrimaryContact"
                            :key="relation.id"
                            class="checkbox"
                        >
                            <kgr-checkbox
                                v-model="relation.isParentAllowedForMoodBarometer"
                                :label="relation.parentUser.fullName()"
                            />
                        </div>
                    </template>

                    <div class="actions clearfix">
                        <kgr-button
                            :value="$t('saveChanges')"
                            :pending="loading"
                            @click="updateParentSettings(relationsScope.data)"
                        />
                    </div>
                </div>
            </template>
        </kgr-child-parent-relations-data-provider>
    </div>
</template>

<script>
import Checkbox from '../../common/form/checkbox/Checkbox.vue';
import ChildMoodRepository from '../../../js/repository/ChildMoodRepository';
import ChildParentRelationsDataProvider from '../../data-provider/ChildParentRelationsDataProvider.vue';
import EmptyData from '../../common/EmptyData.vue';
import KgrButton from '../../common/form/button/KgrButton.vue';

export default {
    components: {
        'kgr-child-parent-relations-data-provider': ChildParentRelationsDataProvider,
        'kgr-checkbox': Checkbox,
        'kgr-empty': EmptyData,
        'kgr-button': KgrButton,
    },
    props: {
        childId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
        };
    },
    methods: {
        updateParentSettings(relations) {
            const allowedParentIds = relations
                .filter((relation) => relation.isParentAllowedForMoodBarometer)
                .map((relation) => relation.parentUser.id);

            this.loading = true;
            ChildMoodRepository.updateAllowedParents(this.childId, allowedParentIds)
                .then(() => this.$notify.success('saveChanges.success'))
                .catch(() => this.$notify.error('saveChanges.error'))
                .finally(() => this.loading = false);
        },
    },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    div > .checkbox {
    margin-top: 10px;
    margin-bottom: 10px;
}
</style>
